import { Accordion } from '@own/fds-react';
import { DyfFeatureGuideContentProps } from '../../../../views/dyf-landing-view/hooks/use-dyf-feature-guide-content';
import './dyf-feature-ribbon.scss';
import React from 'react';
import { FeatureRibbonTooltip } from './feature-ribbon-tooltip/feature-ribbon-tooltip';
import { useFeatureRibbonContent } from '../../../../hooks/dyf/use-feature-ribbon-content/use-feature-ribbon-content';
import { VehicleType } from '../../../../models/experiencefragments/vehicle-type';
import { VehicleYmm } from '../../../../models/vehicle-ymm';

interface FeatureRibbonProps {
    vehicleYmmGroup: VehicleYmm | null;
    eligibleFeatureGuide: boolean;
    eligibleTowingCalculator: boolean;
    vehicleType: VehicleType;
    featureGuideContent: DyfFeatureGuideContentProps;
    vin: string;
}

export interface RibbonComponentContent {
    featureTitle: string;
    featureDescription: string | React.JSX.Element;
    disclaimer: null | string;
    disclaimerIndex: null | number;
}

const RibbonContent: React.FC<{ ribbonElements: RibbonComponentContent[] }> = ({
    ribbonElements,
}): React.JSX.Element => {
    return (
        <React.Fragment>
            {ribbonElements.length > 1 &&
                ribbonElements.map((ribbon: RibbonComponentContent) => (
                    <li
                        key={`ribbon--${encodeURI(ribbon.featureTitle)}`}
                        className="ribbon-item"
                    >
                        <span className="feature-title">
                            {ribbon.featureTitle}
                            {ribbon.disclaimer && (
                                <FeatureRibbonTooltip
                                    superscriptText={`${ribbon.disclaimerIndex}`}
                                    tooltipText={ribbon.disclaimer}
                                />
                            )}
                        </span>
                        <div className="feature-subtitle">
                            {ribbon.featureDescription}
                        </div>
                    </li>
                ))}
        </React.Fragment>
    );
};
const RibbonDesktopView: React.FC<{
    ribbonElements: RibbonComponentContent[];
}> = ({ ribbonElements }) => {
    return (
        <div className="ribbon-view-desktop">
            <ul className="vehicle-features">
                <RibbonContent ribbonElements={ribbonElements} />
            </ul>
        </div>
    );
};

const MobileRibbonHeader: React.FC<{
    featureRibbonAccordionTitle: string;
    accordionSubtitle: string;
}> = ({ featureRibbonAccordionTitle, accordionSubtitle }) => (
    <ul className="header-container">
        <li className="features">
            <span className="accordion-title">
                {featureRibbonAccordionTitle}
            </span>

            <span className="accordion-subtitle">{accordionSubtitle}</span>
        </li>
    </ul>
);

const RibbonMobileView: React.FC<{
    ribbonElements: RibbonComponentContent[];
    featureRibbonAccordionTitle: string;
    accordionSubtitle: string;
}> = ({ ribbonElements, featureRibbonAccordionTitle, accordionSubtitle }) => {
    return (
        <div className="ribbon-view-mobile">
            <Accordion
                panels={[
                    {
                        body: (
                            <ul className="vehicle-features">
                                <RibbonContent
                                    ribbonElements={ribbonElements}
                                />
                            </ul>
                        ),
                        header: (
                            <MobileRibbonHeader
                                featureRibbonAccordionTitle={
                                    featureRibbonAccordionTitle
                                }
                                accordionSubtitle={accordionSubtitle}
                            />
                        ),
                        index: 0,
                    },
                ]}
                theme="light-on-light"
            />
        </div>
    );
};

export const DyfFeatureRibbon = (props: FeatureRibbonProps) => {
    const replaceYMM = (data: string) => {
        return data
            ?.replace('[year]', props?.vehicleYmmGroup?.year.toString() || '')
            .replace('[make]', props?.vehicleYmmGroup?.make || '')
            ?.replace('[model]', props.vehicleYmmGroup?.marketName || '');
    };

    const featureRibbonData = useFeatureRibbonContent(
        props.vin,
        props.vehicleType,
        props.eligibleTowingCalculator
    );

    if (!featureRibbonData || featureRibbonData.length == 0) {
        return <></>;
    }
    return (
        <div className="ribbon-container">
            <RibbonMobileView
                ribbonElements={featureRibbonData}
                featureRibbonAccordionTitle={
                    props.featureGuideContent.featureRibbonAccordionTitle
                }
                accordionSubtitle={replaceYMM(
                    props.featureGuideContent.featureRibbonAccordionDescription
                )}
            />
            <RibbonDesktopView ribbonElements={featureRibbonData} />
        </div>
    );
};
export default DyfFeatureRibbon;
